export const EsriIntegrationTypes = {
  NONE: { id: "1", name: "None" },
  MANAGED_BY_VISLOCK: { id: "2", name: "Managed by Vislock" },
};
